import React, {useCallback,useEffect} from 'react';
import '../style/loginForm.css'
import Dots from 'react-activity/lib/Dots';
import '../style/dots.css';
import GeneralSVG from "./generalSVG";
import RightArrowIcon from "./icons/rightArrowIcon";
import infoIcon from '../info.svg';
import aragLogo from '../araglogo3@2x.png';
import {
    useGoogleReCaptcha
  } from 'react-google-recaptcha-v3';

const LoginForm = (props) =>{
    const { executeRecaptcha } = useGoogleReCaptcha();
      // Create an event handler so you can call the verification on button click event or form submit

    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
        console.log('Execute recaptcha not yet available');
        return;
        }

        const token = await executeRecaptcha('yourAction');

        // Do whatever you want with the token
        if(token){
            props.verifyCallback(token);

    }}, [props.User.madeAttempts]);

  
    // You can use useEffect to trigger the verification as soon as the component being loaded
    useEffect(() => {
        if (props.User.madeAttempts >= 3 && props.User.resetRecaptcha) {
            props.changeUserStateSettings('resetRecaptcha', false);
        }
        }, [props.User.madeAttempts, props.User.resetRecaptcha]);
  
    useEffect(() => {
        handleReCaptchaVerify();
    }, [props.User.madeAttempts]);
      
        return (
            <div className="container ">
                <div className="row ">
                    <div className="col-lg-4 ">
                    </div>
                    <div className="col-lg-4 middle-col-lg-4 ">
                        <div className="wrapperStyle">
                            <img className="logoStyle" src={aragLogo} alt=""/>
                            <form className="formStyle" onSubmit={props.DisplayAuthBox}>
                                <div className="form-group form-group-width">
                                    <label className="formTitleStyle">Login</label>
                                </div>
                                {props.User.infoDialogBoxAppear ?
                                    <div className="arrow_box">
                                        <div className="infoDialogBoxMessage">
                                            Login using your email address or your
                                            username and password
                                        </div>
                                    </div>
                                    : null}
                                <div className="form-group form-group-width">
                                    <label className="elementLabelStyle">Username / email</label>
                                    <img className="infoStyle" src={infoIcon}
                                         onMouseOver={() => props.DisplayDialogBox()}
                                         onMouseLeave={() => props.DisplayDialogBox()}
                                         alt=""/>
                                    <input type="text" placeholder="   Your username or email" name="username"
                                           className="form-control elementStyle" value={props.User.loginFormData.username}
                                           onChange={(evt) => props.HandleInputChange(evt.target.name, evt.target.value)}/>
                                </div>
                                <div className="form-group form-group-width">
                                    <label className="elementLabelStyle">Password</label>
                                    <input type="password" placeholder="  Your password" name="password"
                                           className="form-control elementStyle"
                                           value={props.User.loginFormData.password}
                                           onChange={(evt) => props.HandleInputChange(evt.target.name, evt.target.value)}/>
                                </div>
                                <div className="form-group form-group-width" style={{position: 'relative', height: '34px'}}>
                                    <input type="submit" value="Login"
                                           className="login-form-input-submit"/>
                                    <svg className="login-form-button-arrow"
                                         xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 9.6 16"><title>Asset 2</title>
                                        <g id="Layer_2" data-name="Layer 2">
                                            <g id="Layer_1-2" data-name="Layer 1">
                                                <path
                                                    d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                                <div className="form-group form-group-width no-margin-bottom" onClick={() => props.history.push('/forgot-password')}>
                                    <GeneralSVG
                                        SvgWrapper="sub-heading-link inlineBlock"
                                        Label={'Forgot my password'}
                                        Svg={<RightArrowIcon/>}
                                    />
                                </div>
                            </form>
                            <div className="arrow-down"></div>
                            {
                                (props.User.reCaptchaMessage)?
                                    <div className="rejectAuthDialogBox">
                                        <div className="rejectAuthDialogBoxInfo">{'' +
                                        props.User.reCaptchaMessage}
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                            {props.User.rejectedAuthDialogBox && !(props.User.reCaptchaMessage) ?
                                <div className="rejectAuthDialogBox">
                                    <div className="rejectAuthDialogBoxInfo">{props.User.rejectedAuthDialogBoxData}
                                    </div>
                                </div>
                                :
                                null
                            }
                            {props.User.loggingIn?
                                <div className="col-sm-12">
                                    <div className="col-sm-4"></div>
                                    <div className="col-sm-4">
                                        <Dots /></div>
                                    <div className="col-sm-4"></div>
                                </div>
                                :
                                null
                            }
                        </div>
                    </div>
                    <div className="col-lg-4 "></div>
                </div>
            </div>
        )
}
export default LoginForm;
